import {
  DynamicFlowsApiClient,
  type APIRequestOptions,
  type DSLConfig,
  type DSLConfigStatus,
  type DSLConfigType,
} from '@highereducation/dynamic-flows';
import { getApiConfig } from './utils';

const clientCache = new Map<string, DynamicFlowsApiClient>();

function getClient(): DynamicFlowsApiClient {
  const baseUrl = getApiConfig().dynamicFlowUrl;
  let client = clientCache.get(baseUrl);
  if (!client) {
    client = new DynamicFlowsApiClient({ baseUrl });
    clientCache.set(baseUrl, client);
  }
  return client;
}

export type { DSLConfig, DSLConfigStatus, DSLConfigType };

export type DSLConfigFilters = {
  status?: DSLConfigStatus;
  type?: DSLConfigType;
};

export async function listDslConfigs(
  tenantId: string,
  filters: DSLConfigFilters = {},
  requestHeaders: Record<string, string> = {},
  options: APIRequestOptions = { cacheEnabled: false },
): Promise<{ data: DSLConfig[] | null; error: string | null }> {
  const client = getClient();

  try {
    const data = await client.listDslConfigs(
      tenantId,
      filters,
      requestHeaders,
      options,
    );
    return { data, error: null };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to list DSL configs';
    return { data: null, error: errorMessage };
  }
}

export async function getDslConfig(
  tenantId: string,
  configId: string,
  requestHeaders: Record<string, string> = {},
  options: APIRequestOptions = { cacheEnabled: false },
): Promise<{ data: DSLConfig | null; error: string | null }> {
  const client = getClient();

  try {
    const data = await client.getDslConfig(
      tenantId,
      configId,
      requestHeaders,
      options,
    );
    return { data, error: null };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch DSL config';
    return { data: null, error: errorMessage };
  }
}
